module.exports = __webpack_public_path__ + "static/media/clemente_castor_rata.2b35fd46.png";